// Application form for the Existing / Mature Solution track.
// Shared by every "Apply Now" / "Participate" button on the site so the link
// only has to change in one place.
export const APPLICATION_FORM_URL = "https://forms.gle/h1oe4oBZ1SuiJ7V76";
